var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8ChangeUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.812,
    viewBox: "0 0 16 15.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-change-user_1_",
    "data-name": "icons8-change-user (1)",
    d: "M11.7,4.918a9.154,9.154,0,0,1,7.058,3.321V5.99A.623.623,0,1,1,20,5.99V9.727a.623.623,0,0,1-.623.623H15.64a.623.623,0,1,1,0-1.246h2.216a7.925,7.925,0,0,0-12.718.534.623.623,0,1,1-1.031-.7A9.166,9.166,0,0,1,11.7,4.918Zm0,3.874a2.849,2.849,0,0,1,2.159.915,3.039,3.039,0,0,1,0,3.932,2.849,2.849,0,0,1-2.159.915,2.881,2.881,0,0,1,0-5.762Zm0,1.246a1.635,1.635,0,0,0,0,3.27,1.523,1.523,0,0,0,1.228-.5,1.8,1.8,0,0,0,0-2.277A1.524,1.524,0,0,0,11.7,10.037Zm3.149,5.294a1.406,1.406,0,0,1,1.444,1.353v1.28A2.445,2.445,0,0,1,14.874,20a6.47,6.47,0,0,1-3.177.732A6.474,6.474,0,0,1,8.519,20,2.445,2.445,0,0,1,7.1,17.965v-1.28a1.407,1.407,0,0,1,1.444-1.353Zm0,1.246h-6.3c-.155,0-.2.083-.2.108v1.28c0,.262.207.623.784.95a5.342,5.342,0,0,0,2.564.57,5.335,5.335,0,0,0,2.562-.57c.577-.327.784-.687.784-.95v-1.28C15.043,16.66,15,16.577,14.845,16.577Z",
    transform: "translate(-4 -4.918)",
    fill: "#2A60BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ChangeUser);
export default __webpack_public_path__ + "static/media/icons8-change-user.e54c6dbb7995d68f91b7ba4a9b8d0375.svg";
export { ForwardRef as ReactComponent };